import React from "react";
import { motion, useInView } from "framer-motion";
import "../../styles.css";
import "react-awesome-button/dist/styles.css";

const AboutSection = () => {
  const ref = React.useRef(null);
  const inView = useInView(ref, { triggerOnce: true, threshold: 0.1 });

  const sections = [
    {
      title: "About UIF",
      content: "UIF offers Faith-based financing programs and superior service… At UIF Corp, we are dedicated to providing you with a comprehensive range of faith-based financing solutions tailored to your unique needs. With a solid commitment to exceptional customer service, we take pride in the fact that 97% of our valued customers trust us and enthusiastically refer their family and friends to UIF Corp."
    },
    {
      title: "Our Mission",
      content: "Be the financial institution of choice serving the Muslim community in the United States. Adding additional products & expanding our services to support the Muslim community in all states nationally."
    },
    {
      title: "Experience the UIF difference",
      content: "When clients come to us we treat them as if they are family. Buying a home is a huge milestone in life and UIF is here to walk you through it."
    }
  ];

  return (
    <div
      style={{
        padding: "40px 20px",
        textAlign: "center",
        maxWidth: "900px",
        margin: "0 auto",
        fontFamily: "'Plus Jakarta Sans', sans-serif",
      }}
    >
      {sections.map((section, index) => (
        <motion.div
          key={index}
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 20 }}
          transition={{ duration: 0.8, delay: index * 0.2, ease: "easeInOut" }}
          style={{ marginBottom: "40px" }}
        >
          <h2
            style={{
              fontSize: 28,
              textAlign: "center",
              marginBottom: "20px",
              fontFamily: "'Plus Jakarta Sans', sans-serif",
            }}
          >
            {section.title}
          </h2>
          <p
            style={{
              fontSize: "18px",
              lineHeight: "1.6",
              textAlign: "left",
              margin: 0
            }}
          >
            {section.content}
          </p>
        </motion.div>
      ))}
    </div>
  );
};

export default AboutSection;
